import script from "./Cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cards.vue?vue&type=script&setup=true&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=2a5fad60&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5fad60"]])

export default __exports__